import { Inbox, CheckCircle } from 'lucide-react';
import { memo } from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { accessFormPopupActions } from '@common-reducers/AccessFormPopupReducer';
import { contactsLabelsSelectOneObjectByQuery, labelSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { selectUserObject } from '@common-reducers/UserSelectors';
import { toggleChatLabelThunk } from '@common-reducers/labels-reducer/labels-thunks';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { useTranslation } from 'react-i18next';
import { namespace } from "@common-config/constants";

type Props = {
    waChatId: string,
    size?: number
}

export default memo(function InboxButton({ waChatId, size }: Props) {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()
    const authUser = useAppSelector(selectUserObject);

    const label = useAppSelector(state => {
        return labelSelectOneObjectByQuery(state.DBLabelReducer, {
            type: 'inbox'
        })
    })

    const contactLabel = useAppSelector((state) => contactsLabelsSelectOneObjectByQuery(state.DBContactsLabelsReducer, {
        labelId: label?._id,
        waChatId
    }))

    function toggleInbox(e: React.MouseEvent) {
        e.preventDefault();
        e.stopPropagation();

        if (!authUser?._id) {
            dispatch(accessFormPopupActions.setStatus('Login'));
            return;
        }

        dispatch(toggleChatLabelThunk({
            waChatId: waChatId,
            labelId: label?._id || '',
        }))
    }


    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        className={`group p-1 rounded transition-colors cursor-pointer ${contactLabel ? "text-amber-600 hover:text-green-500" : "text-gray-500 hover:text-amber-600"}`}
                        onClick={toggleInbox}
                    >
                        {contactLabel ? (
                            <>
                                <Inbox size={size || 18} className="currentColor group-hover:hidden" strokeWidth={2} />
                                <CheckCircle size={size || 18} className="currentColor hidden group-hover:block" strokeWidth={2} />
                            </>
                        ) : (
                            <Inbox size={size || 18} className="currentColor" strokeWidth={2} />
                        )}
                    </button>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                    <p>{contactLabel ? t('labels.removeFromInbox') : t('labels.addToInbox')}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
})
